module.exports = __webpack_public_path__ + "static/fonts/iconfont.4af46ae2.woff";